export default "__VITE_ASSET__CTqY2OvN__";